var option_default = {
  "option": "_3Vjxc",
  "user_choice": "-wXW4",
  "check": "_9a4KA",
  "image": "e8m1-",
  "input": "_8QDAl",
  "title": "K11OI",
  "centered": "_7hdV1",
  "with_result": "y-yK8",
  "list": "_1xS1W",
  "with_image": "VBHi7",
  "progress": "BuZw-",
  "progress_value": "PtoCT",
  "label": "iyWLz",
  "cta": "pB1LM",
  "adornment_icon": "muKhA",
  "remove": "j0qvB",
  "removeButton": "_8bd2Y",
  "removeButtonIcon": "WWDC7",
  "overlay": "NW368",
  "shown": "P9AkA",
  "dark": "dWj-y",
  "spinner": "aCbbO",
  "spin": "C4Tv3"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
